<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-xl-2 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('part')"
          prop="partID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-part-number
            :model.sync="form.partID"
            @update:model="updateModelItem('partID', { required: true })"
          ></select-part-number>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('partSN')"
          prop="partSN"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="updateModelItem('partSN', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-1 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,numberInteger')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="updateModelItem('qty', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-4 col-sm-6 col-12 price-field">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style price-field__field"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="updateModelItem('price')"
          />
        </el-form-item>
        <el-form-item
          :label="L10n('currency')"
          prop="currencyID"
          class="material-style price-field__value">
          <select-response
            :model.sync="form.currencyID"
            @update:model="updateModelItem('currencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style">
          <select-response
            :model.sync="form.conditionID"
            @update:model="updateModelItem('conditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('release')"
          prop="releaseID"
          class="material-style">
          <select-response
            :model.sync="form.releaseID"
            @update:model="updateModelItem('releaseID')"
            :isLoading="dataSourceRelease.loading"
            :data="dataSourceRelease.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 order-xl-0 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('tag-info-company')"
          prop="tagInfoCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.tagInfoCompanyID"
            @update:model="updateModelItem('tagInfoCompanyID')"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-xl-2 order-xl-1 col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('tag-date')"
          prop="tagDate"
          class="material-style"
        >
          <date-picker
            v-model="form.tagDate"
            @change="updateModelItem('tagDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-5 order-xl-2 col-md-12 order-md-last col-sm-8 col-12">
        <el-form-item
          :label="L10n('remarks')"
          prop="remarks"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.remarks"
            @input="form.remarks = valueTrimLeft($event)"
            @change="updateModelItem('remarks')"/>
        </el-form-item>
      </div>
      <div class="col-xl-2 order-xl-3 col-md-4 col-sm-4 col-12">
        <el-form-item
          :label="L10n('is-been-chosen')"
          prop="chosen"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.chosen"
            @change="updateModelItem('chosen')">
          </el-checkbox>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormInvoiceDetail',
  mixins: [Form],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title&orderBy=title')
    }
  }
}
</script>
